import { CSSObject } from '@chakra-ui/react';

export const IconContainer: CSSObject = {
  bgGradient: 'linear(to-b, alpha.500, gamma.500)',
  borderRadius: 'lg',
  boxShadow: 'inset 0px 2px 3px rgba(0, 0, 0, 0.25)',

  '& svg': {
    color: 'gamma.800',
  },
};

export const Icon: CSSObject = {
  ml: 'unset',
  color: 'gamma.800',
};

export const MatchCardContainer: CSSObject = {
  bg: 'white',
  display: 'grid',
  alignItems: 'center',
  gridTemplateColumns: '70px 1fr 40px',
  gridTemplateRows: '1fr',
  gridTemplateAreas: `
    "icon matchInfo arrowIcon"
  `,
  boxShadow: '0px 3px 8px rgba(0, 0, 0, 0.2)',
  w: '100%',
  px: '2',
  py: '1.5',

  _hover: {
    bg: 'epsilon.50',
  },
};

export const MatchName: CSSObject = {
  noOfLines: 'unset',
  fontWeight: 'semibold',
  fontSize: ['sm', null, 'md'],
  color: 'epsilon.500',
  mt: '1.5',
};

export const MatchDate: CSSObject = {
  fontSize: 'xs',
  fontWeight: 'extrabold',
  color: 'epsilon.400',
};

export const TeamItemOdds: CSSObject = {
  color: 'yellow.900',
  fontWeight: 'semibold',
  fontSize: 'sm',
};

export const VersusText: CSSObject = {
  display: 'block',
  fontSize: 'md',
  fontWeight: 'semibold',
  color: 'epsilon.500',
};

export const Versus: CSSObject = {
  display: 'flex',
  position: 'absolute',
  borderRadius: 'full',
  boxSize: '12',
  bg: 'yellow.600',
  border: '3px solid',
  borderColor: 'yellow.400',
  boxShadow: '0px 1px 20px 0px #00000080',
  color: 'yellow.900',
  left: '50%',
  transform: 'translate(-50%, 0)',
  top: '84px',

  alignItems: 'center',
  justifyContent: 'center',
};

export const TeamsContainer: CSSObject = {
  flexDir: 'row',
  flex: '1',
  display: 'flex',
  mt: '0',
};

export const TeamItem: CSSObject = {
  border: 'none',
  bg: 'yellow.400',
  '&&': { textColor: 'yellow.900', h: '8' },
  _hover: {
    boxShadow: '0 1px 2px 1px black',
    transform: 'translateY(-3%)',
  },
};

export const TeamItemName: CSSObject = {
  fontSize: 'sm',
  color: 'white',
  mb: '1.5',
  fontWeight: 'semibold',
};

export const Seperator: CSSObject = {
  color: 'gray.300',
  mx: '0',
  px: '0',
};
export const NameContainer: CSSObject = {
  gridTemplateColumns: '70px 1fr 40px',
  gridTemplateRows: '1fr',
  gridTemplateAreas: `
  "icon matchInfo arrowIcon"
`,
};

export const TextSpanName = (isVS: boolean): CSSObject => ({
  color: 'epsilon.500',
  ...(isVS && { color: 'epsilon.500' }),
});

export const CompetitionName: CSSObject = {
  fontSize: 'xs',
  fontWeight: 'extrabold',
  color: 'epsilon.400',
};

export const ArrowIcon: CSSObject = {
  boxSize: '7',
  color: 'beta.700',
  border: '1px',
  borderColor: 'beta.700',
  borderRadius: 'full',
};

export const MatchDetails: CSSObject = {
  py: '0',
};

export const BodyContainer: CSSObject = {
  py: '1',
};
